export const types = [
  'Total',
  'Type',
  'Type II',
  'Nationality',
  'Gender',
  'Associated Companies',
  'Catalysts',
  'Catalysts II',
  'Creatives',
  'Designers',
  'Executives',
  'Fashion 2.0',
  'Media',
  'Models',
  'Retailers'
]

export function oddsRatio (phenomenon_i, phenomenon_total, random_i, random_total) {
  return (
    (phenomenon_i + 1.0) /
      phenomenon_total /
      ((random_i + 1.0) / random_total)
  )
}

export function oddsRatioCI (
  phenomenon_i,
  phenomenon_total,
  random_i,
  random_total,
  z = 1.96
) {
  const or = oddsRatio(
    phenomenon_i,
    phenomenon_total,
    random_i,
    random_total
  )
  return Math.exp(
    Math.log(or) -
        z *
          Math.sqrt(
            1 / (phenomenon_i + 1) +
              1 / phenomenon_total +
              1 / (random_i + 1) +
              1 / random_total
          )
  )
}

export function columnToOddsRatioCI (columnName, data, totals) {
  const phenomenon_total = totals[columnName]
  const random_total = totals.random
  const or = []
  const opacity = []
  for (let index = 0; index < data.length; index++) {
    const row = data[index]
    const phenomenon_i = row[columnName]
    const random_i = row.random
    or.push(
      oddsRatioCI(phenomenon_i, phenomenon_total, random_i, random_total)
    )
    opacity.push(phenomenon_i > 10 ? 1 : 0)
  }
  return {
    or: or,
    orOpacity: opacity
  }
}

export function compareColumnsOddsRatio (columnName1, columnName2, data, totals) {
  const phenomenon_total = totals[columnName1]
  const random_total = totals[columnName2]
  const or = []
  const opacity = []
  for (let index = 0; index < data.length; index++) {
    const row = data[index]
    const phenomenon_i = row[columnName1]
    const random_i = row[columnName2]
    or.push(
      oddsRatio(phenomenon_i, phenomenon_total, random_i, random_total)
    )
    opacity.push(phenomenon_i > 30 || random_i > 30 ? 1 : 0)
  }
  return {
    or: or,
    orOpacity: opacity
  }
}
